import {useSubheader} from "../../../_metronic/layout";
import React, {useState} from "react";
import {useFormik} from "formik";
import * as Yup from "yup";
import {useHistory} from "react-router-dom";
import makeRequest from "../../api/makeRequest";
import {useTranslation} from "react-i18next";


const initialValues = {
	name: "",
	username: "",
	password: "",
};

export const NewUserPage = () => {
	const { t } = useTranslation('common');
	const suhbeader = useSubheader();
	suhbeader.setTitle(t('NewUser'));

	const [loading, setLoading] = useState(false);
	const [okMessage,setOkMessage] = useState('');
	const LoginSchema = Yup.object().shape({
		name: Yup.string()
			.required(
				t('PleaseName')
			),
		username: Yup.string()
			.min(3, t('AtLeastCharacters'))
			.required(
				t('PleaseUserName')
			),
		password: Yup.string()
			.min(3, t('AtLeastCharacters'))
			.required(
				t('PleasePassword')
			),
	});

	const enableLoading = () => {
		setLoading(true);
	};

	const disableLoading = () => {
		setLoading(false);
	};

	const getInputClasses = (fieldname) => {
		if (formik.touched[fieldname] && formik.errors[fieldname]) {
			return "is-invalid";
		}

		if (formik.touched[fieldname] && !formik.errors[fieldname]) {
			return "is-valid";
		}

		return "";
	};

	let history = useHistory();

	const formik = useFormik({
		initialValues,
		validationSchema: LoginSchema,
		onSubmit: async (values, {setStatus, setSubmitting}) => {
			enableLoading();
			makeRequest('createUser', {
				"name": values.name,
				"username": values.username,
				"password": values.password,
			}).then(({data}) => {
				const {success} = data
				if(success) {
					setOkMessage(t('UserBuilt'))
					setTimeout(()=>{
						history.push('/user')
					},1000)
				}else{
					const {error} = data
					setSubmitting(false);
					setStatus(error)
				}
			}).catch((e) => {
				setSubmitting(false);
				setStatus(t('Error'))
			}).finally(() => {
				disableLoading();
			})
		},
	});

	return (
		<>
			<form
				onSubmit={formik.handleSubmit}
				className="form fv-plugins-bootstrap fv-plugins-framework"
			>
				{formik.status ? (
					<div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
						<div className="alert-text font-weight-bold">{formik.status}</div>
					</div>
				) : null}
				{okMessage ? (
					<div className="mb-10 alert alert-custom alert-light-success alert-dismissible">
						<div className="alert-text font-weight-bold">{okMessage}</div>
					</div>
				) : null}

				<div className="form-group fv-plugins-icon-container">
					<input
						placeholder={t('AUTH.INPUT.FULLNAME')}
						type="text"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"name"
						)}`}
						name="name"
						{...formik.getFieldProps("name")}
					/>
					{formik.touched.name && formik.errors.name ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.name}</div>
						</div>
					) : null}
				</div>
				<div className="form-group fv-plugins-icon-container">
					<input
						placeholder={t('AUTH.INPUT.USERNAME')}
						type="text"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"username"
						)}`}
						name="username"
						{...formik.getFieldProps("username")}
					/>
					{formik.touched.username && formik.errors.username ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.username}</div>
						</div>
					) : null}
				</div>
				<div className="form-group fv-plugins-icon-container">
					<input
						placeholder={t('AUTH.INPUT.PASSWORD')}
						type="password"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"password"
						)}`}
						name="password"
						{...formik.getFieldProps("password")}
					/>
					{formik.touched.password && formik.errors.password ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.password}</div>
						</div>
					) : null}
				</div>
				<div className="form-group d-flex flex-wrap justify-content-between align-items-center">
					<button
						id="kt_login_signin_submit"
						type="submit"
						disabled={formik.isSubmitting}
						className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
					>
						<span>{t('Create')}</span>
						{loading && <span className="blockui m-1 ml-3 spinner spinner-white"/>}
					</button>
				</div>
			</form>
		</>
	)
}
